import React from "react"
import "../../../assets/scss/components/app-loader.scss"
import MaOfficialLogo from '../../../assets/img/logo/Movie-Analyzer-logo.png';
class SpinnerComponent extends React.Component {
  render() {
    return (
      <div className="fallback-spinner vh-100 text-center">
        <img className="fallback-logo" src={MaOfficialLogo} alt="logo" width={'200px'}/>
        <div className="loading">
          <div className="effect-1 effects"></div>
          <div className="effect-2 effects"></div>
          <div className="effect-3 effects"></div>
        </div>
      </div>
    )
  }
}

export default SpinnerComponent
